/* eslint-disable no-bitwise */
/* eslint-disable no-extend-native */
/* eslint-disable func-names */
/* eslint-disable no-prototype-builtins */
(function (arr) {
  arr.forEach((item) => {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode === null) {
          return;
        }
        this.parentNode.removeChild(this);
      },
    });
  });
}([Element.prototype, CharacterData.prototype, DocumentType.prototype]));

Object.defineProperty(String.prototype, 'hashCode', {
  value() {
    let hash = 0; let i; let
      chr;
    for (i = 0; i < this.length; i += 1) {
      chr = this.charCodeAt(i);
      hash = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  },
});
